import Home from "./pages/home";
import LaundryCapsulesPage from "./pages/packed-bubble/laundry-capsules-page";
import LaundryLiquidPage from "./pages/packed-bubble/laundry-liquid-page";
import LaundryPowderPage from "./pages/packed-bubble/laundry-powder-page";
import LaundryGelPage from "./pages/packed-bubble/laundry-gel-page";
import LaundryAdditivesPage from "./pages/packed-bubble/laundry-additives-page";
import FabricConditionersPage from "./pages/fabric/conditioners";
import FabricRefreshersPage from "./pages/fabric/refreshers";
import FabricTumblePage from "./pages/fabric/tumble";
import FabricIroningPage from "./pages/fabric/ironing";
import SheetExamplePage from "./pages/sheet-example";
import DonutPage from "./pages/donut";
import DonutFabricPage from "./pages/donut-fabric";
import PersonalCareAdultDonut from "./pages/personal-care/adult-incontinence/donut";
import PadsBubbleChart from "./pages/personal-care/adult-incontinence/bubbles/pads";
import LinersBubbleChart from "./pages/personal-care/adult-incontinence/bubbles/liners";
import PantsBubbleChart from "./pages/personal-care/adult-incontinence/bubbles/pants";
import PcBodyDonut from "./pages/personal-care/body-sprays/donut";
import FemaleAntiPerspirantBubbleChart from "./pages/personal-care/body-sprays/bubbles/female-antiperspirant";
import FemaleBodySpraysBubbleChart from "./pages/personal-care/body-sprays/bubbles/female-bodysprays";
import MaleAntiPerspirantBubbleChart from "./pages/personal-care/body-sprays/bubbles/male-antiperspirant";
import MaleBodySpraysBubbleChart from "./pages/personal-care/body-sprays/bubbles/male-bodysprays";
import PcHairCareDonut from "./pages/personal-care/hair-care/donut";
import HcConditionerBubbleChart from "./pages/personal-care/hair-care/bubbles/conditioner";
import HcShampooBubbleChart from "./pages/personal-care/hair-care/bubbles/shampoo";
import HcStylingBubbleChart from "./pages/personal-care/hair-care/bubbles/styling";
import PcOralCareDonut from "./pages/personal-care/oral-care/donut";
import HcMouthWashBubbleChart from "./pages/personal-care/oral-care/bubbles/mouthwash";
import HcToothbrushesBubbleChart from "./pages/personal-care/oral-care/bubbles/toothbrushes";
import HcToothpastesBubbleChart from "./pages/personal-care/oral-care/bubbles/toothpastes";
import ConditionersBubbleChart from "./pages/laundry/fabric-conditioners/bubbles/conditioners";
import RefreshersBubbleChart from "./pages/laundry/fabric-conditioners/bubbles/refreshers";
import SheetsBubbleChart from "./pages/laundry/fabric-conditioners/bubbles/sheets";
import AidsBubbleChart from "./pages/laundry/fabric-conditioners/bubbles/aids";
import FabricConditionersDonutChart from "./pages/laundry/fabric-conditioners/donut";
import LaundryDonutChart from "./pages/laundry/laundry/donut";
import PowderBubbleChart from "./pages/laundry/laundry/bubbles/powder";
import LiquidBubbleChart from "./pages/laundry/laundry/bubbles/liquid";
import GelBubbleChart from "./pages/laundry/laundry/bubbles/gel";
import AdditivesBubbleChart from "./pages/laundry/laundry/bubbles/additives";
import HouseHoldAdditivesBubbleChart from "./pages/household/dish/bubbles/additives";
import PeriodDonut from "./pages/personal-care/period/donut";
import PeriodLinersBubbleChart from "./pages/personal-care/period/bubbles/liners";
import PeriodPadsBubbleChart from "./pages/personal-care/period/bubbles/pads";
import PeriodTamponsBubbleChart from "./pages/personal-care/period/bubbles/tampons";
import ShavingDonut from "./pages/personal-care/shaving/donut";
import ShavingBladesBubbleChart from "./pages/personal-care/shaving/bubbles/blades";
import ShavingDisposableBubbleChart from "./pages/personal-care/shaving/bubbles/disposable";
import ShavingRazorsBubbleChart from "./pages/personal-care/shaving/bubbles/razors";
import ShavingGelsFoamsBubbleChart from "./pages/personal-care/shaving/bubbles/shaving";
import CapsulesBubbleChart from "./pages/laundry/laundry/bubbles/capsules";
import SkinDonut from "./pages/personal-care/skin/donut";
import SkinBodyBubbleChart from "./pages/personal-care/skin/bubbles/body";
import SkinFacialBubbleChart from "./pages/personal-care/skin/bubbles/facial";
import SkinHandBubbleChart from "./pages/personal-care/skin/bubbles/hand";
import SkinLipBubbleChart from "./pages/personal-care/skin/bubbles/lip";
import SkinMaleBubbleChart from "./pages/personal-care/skin/bubbles/male";
import SkinMoisturisingBubbleChart from "./pages/personal-care/skin/bubbles/moisturising";
import WashingShavingDonutChart from "./pages/personal-care/washing-bathing/donut";
import ShowerBubbleChart from "./pages/personal-care/washing-bathing/bubbles/shower";
import HandWashBubbleChart from "./pages/personal-care/washing-bathing/bubbles/handWash";
import HandGelBubbleChart from "./pages/personal-care/washing-bathing/bubbles/handGel";
import BarSoapBubbleChart from "./pages/personal-care/washing-bathing/bubbles/barSoap";
import BathAdditivesBubbleChart from "./pages/personal-care/washing-bathing/bubbles/bathAdditives";
import HHAirDonut from "./pages/household/air-care/donut";
import AerosolsBubbleChart from "./pages/household/air-care/bubbles/aerosols";
import AmbientBubbleChart from "./pages/household/air-care/bubbles/ambient";
import AutomaticBubbleChart from "./pages/household/air-care/bubbles/automatic";
import CandlesBubbleChart from "./pages/household/air-care/bubbles/candles";
import CarpetBubbleChart from "./pages/household/air-care/bubbles/carpet";
import ElectricalBubbleChart from "./pages/household/air-care/bubbles/electrical";
import ReedsBubbleChart from "./pages/household/air-care/bubbles/reeds";
import HHBleachToiletDonut from "./pages/household/bleach-toilet/donut";
import BleachBubbleChart from "./pages/household/bleach-toilet/bubbles/bleach";
import CisternBlockBubbleChart from "./pages/household/bleach-toilet/bubbles/cistern";
import RimBlockBubbleChart from "./pages/household/bleach-toilet/bubbles/rim";
import ToiletBubbleChart from "./pages/household/bleach-toilet/bubbles/toilet";
import HHDishDonut from "./pages/household/dish/donut";
import DishwasherBubbleChart from "./pages/household/dish/bubbles/dishwasher";
import WashingBubbleChart from "./pages/household/dish/bubbles/washing";
import HHCleaningDonut from "./pages/household/cleaning/donut";
import BathBubbleChart from "./pages/household/cleaning/bubbles/bath";
import FloorBubbleChart from "./pages/household/cleaning/bubbles/floor";
import KitchenBubbleChart from "./pages/household/cleaning/bubbles/kitchen";
import MultipurposeBubbleChart from "./pages/household/cleaning/bubbles/multipurpose";
import HHPaperDonut from "./pages/household/paper/donut";
import { FacialBubbleChart } from "./pages/household/paper/bubbles/facial";
import WetBubbleChart from "./pages/household/paper/bubbles/wet";
import ToiletPaperBubbleChart from "./pages/household/paper/bubbles/toilet";
import { WipesBubbleChart } from "./pages/household/paper/bubbles/wipes";
import HHSpecialistCleaningDonut from "./pages/household/specialist-cleaning/donut";
import { ApplianceBubbleChart } from "./pages/household/specialist-cleaning/bubbles/appliance";
import { CarpetCleanersBubbleChart } from "./pages/household/specialist-cleaning/bubbles/carpet-cleaners";
import { DisinfectantsBubbleChart } from "./pages/household/specialist-cleaning/bubbles/disinfectants";
import { DrainUnblockersBubbleChart } from "./pages/household/specialist-cleaning/bubbles/drainunblockers";
import { KitchenBubbleChart as KitchenSpecialBubbleChart } from "./pages/household/specialist-cleaning/bubbles/kitchen";
import { LimaScaleGlassBubbleChart } from "./pages/household/specialist-cleaning/bubbles/limescale";
import { MouldMildewBubbleChart } from "./pages/household/specialist-cleaning/bubbles/mould-mildew";
import { WindowGlassBubbleChart } from "./pages/household/specialist-cleaning/bubbles/window-glass";
import BabyDonutChart from "./pages/baby/donut";
import { WipesBabyBubbleChart } from "./pages/baby/bubbles/wipes";
import { ToiletriesBabyBubbleChart } from "./pages/baby/bubbles/toiletries";
import { NappiesBabyBubbleChart } from "./pages/baby/bubbles/nappies";
import { MilkBabyBubbleChart } from "./pages/baby/bubbles/milk";
import { BabyFoodBubbleChart } from "./pages/baby/bubbles/baby";
import { MedicinesDonutChart } from "./pages/medicines/donut";
import { AdultPainBubbleChart } from "./pages/medicines/bubbles/adult-pain";
import { AllergyBubbleChart } from "./pages/medicines/bubbles/allergy";
import { BodyHealthBubbleChart } from "./pages/medicines/bubbles/body-health";
import { ChildrenMedicinesBubbleChart } from "./pages/medicines/bubbles/child-med";
import { ColdFluBubbleChart } from "./pages/medicines/bubbles/cold-flu";
import { CoughBubbleChart } from "./pages/medicines/bubbles/cough";
import { DecoBubbleChart } from "./pages/medicines/bubbles/deco";
import { DigestionBubbleChart } from "./pages/medicines/bubbles/digestion";
import { FirstAidBubbleChart } from "./pages/medicines/bubbles/first-aid";
import { HeartburnBubbleChart } from "./pages/medicines/bubbles/heartburn";
import { SexualBubbleChart } from "./pages/medicines/bubbles/sexual";
import { SoreBubbleChart } from "./pages/medicines/bubbles/sore";
import Demo from "./pages/demo";
import PowerBrands from "./pages/power-brands";
import CarBubbleChart from "./pages/household/air-care/bubbles/car";
import PetCareDonutChart from "./pages/pet-care/donut";
import { CatFoodBubbleChart } from "./pages/pet-care/bubbles/cat-food";
import { DogFoodBubbleChart } from "./pages/pet-care/bubbles/dog-food";
import { OtherAnimalBubbleChart } from "./pages/pet-care/bubbles/other-animal";
import { FurniturePolishBubbleChart } from "./pages/household/specialist-cleaning/bubbles/furniture-polish";

export const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/demo",
    element: <Demo />,
  },
  {
    path: "/power-brands",
    element: <PowerBrands />,
  },
  // {
  //   path: "/sheet-example",
  //   element: <SheetExamplePage />,
  // },
  // {
  //   path: "/donut",
  //   element: <DonutPage />,
  // },
  // {
  //   path: "/donut-fabric",
  //   element: <DonutFabricPage />,
  // },
  // // Laundry
  // {
  //   path: "/laundry-capsules",
  //   element: <LaundryCapsulesPage />,
  // },
  // {
  //   path: "/laundry-powder",
  //   element: <LaundryPowderPage />,
  // },
  // {
  //   path: "/laundry-liquid",
  //   element: <LaundryLiquidPage />,
  // },
  // {
  //   path: "/laundry-gel",
  //   element: <LaundryGelPage />,
  // },
  // {
  //   path: "/laundry-additives",
  //   element: <LaundryAdditivesPage />,
  // },
  // // Fabric
  // {
  //   path: "/fabric-conditioners",
  //   element: <FabricConditionersPage />,
  // },
  // {
  //   path: "/fabric-refreshers",
  //   element: <FabricRefreshersPage />,
  // },
  // {
  //   path: "/fabric-tumble",
  //   element: <FabricTumblePage />,
  // },
  // {
  //   path: "/fabric-ironing",
  //   element: <FabricIroningPage />,
  // },
  // Personal Care - First
  {
    path: "/personal-care/adult/donut",
    element: <PersonalCareAdultDonut />,
  },
  {
    path: "/personal-care/adult/pads",
    element: <PadsBubbleChart />,
  },
  {
    path: "/personal-care/adult/liners",
    element: <LinersBubbleChart />,
  },
  {
    path: "/personal-care/adult/pants",
    element: <PantsBubbleChart />,
  },
  {
    path: "/personal-care/body-sprays/donut",
    element: <PcBodyDonut />,
  },
  {
    path: "/personal-care/body-sprays/female-ap",
    element: <FemaleAntiPerspirantBubbleChart />,
  },
  {
    path: "/personal-care/body-sprays/female-bs",
    element: <FemaleBodySpraysBubbleChart />,
  },
  {
    path: "/personal-care/body-sprays/male-ap",
    element: <MaleAntiPerspirantBubbleChart />,
  },
  {
    path: "/personal-care/body-sprays/male-bs",
    element: <MaleBodySpraysBubbleChart />,
  },
  {
    path: "/personal-care/hair-care/donut",
    element: <PcHairCareDonut />,
  },
  {
    path: "/personal-care/hair-care/conditioner",
    element: <HcConditionerBubbleChart />,
  },
  {
    path: "/personal-care/hair-care/shampoo",
    element: <HcShampooBubbleChart />,
  },
  {
    path: "/personal-care/hair-care/styling",
    element: <HcStylingBubbleChart />,
  },
  {
    path: "/personal-care/oral-care/donut",
    element: <PcOralCareDonut />,
  },
  {
    path: "/personal-care/oral-care/mouthwash",
    element: <HcMouthWashBubbleChart />,
  },
  {
    path: "/personal-care/oral-care/toothbrushes",
    element: <HcToothbrushesBubbleChart />,
  },
  {
    path: "/personal-care/oral-care/toothpastes",
    element: <HcToothpastesBubbleChart />,
  },
  {
    path: "/personal-care/period/donut",
    element: <PeriodDonut />,
  },
  {
    path: "/personal-care/period/liners",
    element: <PeriodLinersBubbleChart />,
  },
  {
    path: "/personal-care/period/pads",
    element: <PeriodPadsBubbleChart />,
  },
  {
    path: "/personal-care/period/tampons",
    element: <PeriodTamponsBubbleChart />,
  },
  {
    path: "/personal-care/shaving/donut",
    element: <ShavingDonut />,
  },
  {
    path: "/personal-care/shaving/blades",
    element: <ShavingBladesBubbleChart />,
  },
  {
    path: "/personal-care/shaving/disposable",
    element: <ShavingDisposableBubbleChart />,
  },
  {
    path: "/personal-care/shaving/razors",
    element: <ShavingRazorsBubbleChart />,
  },
  {
    path: "/personal-care/shaving/shaving",
    element: <ShavingGelsFoamsBubbleChart />,
  },
  {
    path: "/personal-care/skin/donut",
    element: <SkinDonut />,
  },
  {
    path: "/personal-care/skin/body",
    element: <SkinBodyBubbleChart />,
  },
  {
    path: "/personal-care/skin/facial",
    element: <SkinFacialBubbleChart />,
  },
  {
    path: "/personal-care/skin/hand",
    element: <SkinHandBubbleChart />,
  },
  {
    path: "/personal-care/skin/lip",
    element: <SkinLipBubbleChart />,
  },
  {
    path: "/personal-care/skin/male",
    element: <SkinMaleBubbleChart />,
  },
  {
    path: "/personal-care/skin/moisturising",
    element: <SkinMoisturisingBubbleChart />,
  },
  {
    path: "/personal-care/washing-bathing/donut",
    element: <WashingShavingDonutChart />,
  },
  {
    path: "/personal-care/washing-bathing/shower",
    element: <ShowerBubbleChart />,
  },
  {
    path: "/personal-care/washing-bathing/hand-wash",
    element: <HandWashBubbleChart />,
  },
  {
    path: "/personal-care/washing-bathing/hand-gel",
    element: <HandGelBubbleChart />,
  },
  {
    path: "/personal-care/washing-bathing/bar-soap",
    element: <BarSoapBubbleChart />,
  },
  {
    path: "/personal-care/washing-bathing/bath-additives",
    element: <BathAdditivesBubbleChart />,
  },
  // Fabric Conditioner charts
  {
    path: "/laundry/fabric-conditioners/donut",
    element: <FabricConditionersDonutChart />,
  },
  {
    path: "/laundry/fabric-conditioners/conditioners",
    element: <ConditionersBubbleChart />,
  },
  {
    path: "/laundry/fabric-conditioners/refreshers",
    element: <RefreshersBubbleChart />,
  },
  {
    path: "/laundry/fabric-conditioners/sheets",
    element: <SheetsBubbleChart />,
  },
  {
    path: "/laundry/fabric-conditioners/aids",
    element: <AidsBubbleChart />,
  },
  // Laundry charts
  {
    path: "/laundry/laundry-charts/donut",
    element: <LaundryDonutChart />,
  },
  {
    path: "/laundry/laundry-charts/powder",
    element: <PowderBubbleChart />,
  },
  {
    path: "/laundry/laundry-charts/liquid",
    element: <LiquidBubbleChart />,
  },
  {
    path: "/laundry/laundry-charts/gel",
    element: <GelBubbleChart />,
  },
  {
    path: "/laundry/laundry-charts/additives",
    element: <AdditivesBubbleChart />,
  },
  {
    path: "/laundry/laundry-charts/capsules",
    element: <CapsulesBubbleChart />,
  },
  // HouseHold Charts
  {
    path: "/house-hold/air-care/donut",
    element: <HHAirDonut />,
  },
  {
    path: "/house-hold/air-care/car",
    element: <CarBubbleChart />,
  },
  {
    path: "/house-hold/air-care/aerosols",
    element: <AerosolsBubbleChart />,
  },
  {
    path: "/house-hold/air-care/ambient",
    element: <AmbientBubbleChart />,
  },
  {
    path: "/house-hold/air-care/automatic",
    element: <AutomaticBubbleChart />,
  },
  {
    path: "/house-hold/air-care/candles",
    element: <CandlesBubbleChart />,
  },
  {
    path: "/house-hold/air-care/carpet",
    element: <CarpetBubbleChart />,
  },
  {
    path: "/house-hold/air-care/electrical",
    element: <ElectricalBubbleChart />,
  },
  // {
  //   path: "/house-hold/air-care/reeds",
  //   element: <ReedsBubbleChart />,
  // },
  {
    path: "/house-hold/bleach-toilet/donut",
    element: <HHBleachToiletDonut />,
  },
  {
    path: "/house-hold/bleach-toilet/bleach",
    element: <BleachBubbleChart />,
  },
  {
    path: "/house-hold/bleach-toilet/cistern",
    element: <CisternBlockBubbleChart />,
  },
  {
    path: "/house-hold/bleach-toilet/rim",
    element: <RimBlockBubbleChart />,
  },
  {
    path: "/house-hold/bleach-toilet/toilet",
    element: <ToiletBubbleChart />,
  },
  {
    path: "/house-hold/dish/donut",
    element: <HHDishDonut />,
  },
  {
    path: "/house-hold/dish/additives",
    element: <HouseHoldAdditivesBubbleChart />,
  },
  {
    path: "/house-hold/dish/dishwasher",
    element: <DishwasherBubbleChart />,
  },
  {
    path: "/house-hold/dish/washing",
    element: <WashingBubbleChart />,
  },
  {
    path: "/house-hold/cleaning/donut",
    element: <HHCleaningDonut />,
  },
  {
    path: "/house-hold/cleaning/bath",
    element: <BathBubbleChart />,
  },
  {
    path: "/house-hold/cleaning/floor",
    element: <FloorBubbleChart />,
  },
  {
    path: "/house-hold/cleaning/kitchen",
    element: <KitchenBubbleChart />,
  },
  {
    path: "/house-hold/cleaning/multipurpose",
    element: <MultipurposeBubbleChart />,
  },
  {
    path: "/house-hold/paper/donut",
    element: <HHPaperDonut />,
  },
  {
    path: "/house-hold/paper/facial",
    element: <FacialBubbleChart />,
  },
  {
    path: "/house-hold/paper/toilet",
    element: <ToiletPaperBubbleChart />,
  },
  {
    path: "/house-hold/paper/wet",
    element: <WetBubbleChart />,
  },
  {
    path: "/house-hold/paper/wipes",
    element: <WipesBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/donut",
    element: <HHSpecialistCleaningDonut />,
  },
  {
    path: "/house-hold/specialist-cleaning/appliance",
    element: <ApplianceBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/carpet-cleaners",
    element: <CarpetCleanersBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/disinfectants",
    element: <DisinfectantsBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/drain-unblockers",
    element: <DrainUnblockersBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/furniture-polish",
    element: <FurniturePolishBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/kitchen",
    element: <KitchenSpecialBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/limescale",
    element: <LimaScaleGlassBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/mould-mildew",
    element: <MouldMildewBubbleChart />,
  },
  {
    path: "/house-hold/specialist-cleaning/window-glass",
    element: <WindowGlassBubbleChart />,
  },
  // ... Baby Charts
  {
    path: "/baby/donut",
    element: <BabyDonutChart />,
  },
  {
    path: "/baby/wipes",
    element: <WipesBabyBubbleChart />,
  },
  {
    path: "/baby/toiletries",
    element: <ToiletriesBabyBubbleChart />,
  },
  {
    path: "/baby/nappies",
    element: <NappiesBabyBubbleChart />,
  },
  {
    path: "/baby/milk",
    element: <MilkBabyBubbleChart />,
  },
  {
    path: "/baby/food",
    element: <BabyFoodBubbleChart />,
  },
  // ... Medicines Charts
  {
    path: "/medicines/donut",
    element: <MedicinesDonutChart />,
  },
  {
    path: "/medicines/adult-pain",
    element: <AdultPainBubbleChart />,
  },
  {
    path: "/medicines/allergy",
    element: <AllergyBubbleChart />,
  },
  {
    path: "/medicines/body-health",
    element: <BodyHealthBubbleChart />,
  },
  {
    path: "/medicines/children-med",
    element: <ChildrenMedicinesBubbleChart />,
  },
  {
    path: "/medicines/cold-flu",
    element: <ColdFluBubbleChart />,
  },
  {
    path: "/medicines/cough",
    element: <CoughBubbleChart />,
  },
  {
    path: "/medicines/deco",
    element: <DecoBubbleChart />,
  },
  {
    path: "/medicines/digestion",
    element: <DigestionBubbleChart />,
  },
  {
    path: "/medicines/first-aid",
    element: <FirstAidBubbleChart />,
  },
  {
    path: "/medicines/heartburn",
    element: <HeartburnBubbleChart />,
  },
  {
    path: "/medicines/sexual",
    element: <SexualBubbleChart />,
  },
  {
    path: "/medicines/sore",
    element: <SoreBubbleChart />,
  },
  // Pet food
  {
    path: "/pet-care/donut",
    element: <PetCareDonutChart />,
  },
  {
    path: "/pet-care/cat-food",
    element: <CatFoodBubbleChart />,
  },
  {
    path: "/pet-care/dog-food",
    element: <DogFoodBubbleChart />,
  },
  {
    path: "/pet-care/other-animal",
    element: <OtherAnimalBubbleChart />,
  },
];
